module.exports = __webpack_public_path__ + "img/headLeft2Logo.fb6fbd02.png";